<template>
<div v-bind:class="{ interactive: interactive}" class="sidebar-item avatar">
    <span v-if="this.user">{{this.user.initials}}</span>
    <span v-else>🐶</span>
</div>
</template>

<script>
export default {
  name: 'avatar',
  props: {
    user: Object,
    interactive: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  height: 55px;
  width: 55px;
  border: $default-color thin solid;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $default-color;
  background-color: $default-color-background;
  transition: $transition-length;
}

.avatar span{
  font-size: 18px;
}

.interactive {
  cursor: pointer;
}
.interactive:hover{
  color: $default-color;
  background-color: #FFFFFF;
}
</style>
